import { DotLegalOverflowMenuItem } from "@dotlegal/dotlegal-ui-components";
import { getPlanDialogOverflowMenuItem } from "../../../plan/planOverflowMenuItem/PlanOverflowMenuItem.tsx";

/** The missing add-on wins over the size: it is the reason the customer can do something about. */
export function getAiQualityScanOverflowMenuItem(
    onClick: () => void,
    planActivated: boolean,
    isTooLargeForAi: boolean,
    translateString: (key: string) => string
): DotLegalOverflowMenuItem {
    if (planActivated && isTooLargeForAi) {
        return {
            menuItem: translateString("aiQualityScan"),
            disabled: true,
            tooltip: translateString("textExtractionErrorFileTooLarge"),
            tooltipPosition: "left",
        };
    }

    return getPlanDialogOverflowMenuItem(onClick, planActivated, translateString("aiQualityScan"), translateString("aiAddOnPurchaseTooltip"));
}
